<template>
    <v-form v-if="dataSource && dataSource.length > 0" class="wrapperForm">
        <v-row dense>
            <v-col cols="12" sm="12" md="12" class="section-wrapper">

                <v-card flat v-for="(takeNoteList, i) in dataSource" :key="i">

                    <v-card-text>

                        <div class="form-box-title title-with-right-part">

                            <span>{{getTitleCard(takeNoteList.CreateDate)}}</span>

                        </div>

                        <v-row class="full-width-row" no-gutters>
                            <v-col cols="12" sm="12" md="2">
                                <label class="f-label">{{$t("Инициатор")}}</label>
                            </v-col>
                            <v-col  cols="12" sm="12" md="10">
                                <div class="onlyReadData more-per-lab-wrap">

                                    <v-employee-chip :id="takeNoteList.InitiatorID" :name="takeNoteList.InitiatorName" />

                                    <template v-if="takeNoteList.IsWithdrawn">
                                        <span>({{$t("Ознакомление_отменено_инициатором")}})</span>
                                    </template>

                                </div>
                            </v-col>
                        </v-row>

                        <v-row class="full-width-row" no-gutters>

                            <v-col cols="12" sm="12" md="2">
                                <label class="f-label">{{$t("Результат_ознакомления")}}</label>
                            </v-col>
                            <v-col  cols="12" sm="12" md="10">
                                <template v-for="takeNote in getTakeNotes(takeNoteList)">

                                    <div class="onlyReadData more-per-lab-wrap"  :key="takeNote.SignerID">

                                        <span v-if="takeNote.SignDate">{{takeNote.SignDate | formattedDate}}</span>
                                        <span v-else>{{$t('не_ознакомлен')}}</span>

                                        <v-workplace-chip :id="takeNote.SignerID" :name="takeNote.SignerName" :iconColor="takeNote.SignDate ? '#43B581' : null" />

                                        <StatusChip v-if="takeNote.SignDate" :status="doneStatus"/>

                                    </div>

                                </template>
                            </v-col>
                            
                        </v-row>

                    </v-card-text>
                </v-card>

            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
import sys from "@/services/system"
import StatusChip from '@/components/global/chips/StatusChip'

export default {
    name: "takenotelist-tab",
    props: {
        id: {
            type: String,
            default: null,
            
        }
    },
    components: {
        StatusChip,
    },
    data() {
        return {
            doneStatus: {
                text: "Ознакомлен",
                style: {
                    'background-color': "#43B581"
                }
            },
        }
    },
    computed: {
        ...mapGetters('global/actionsource', { documentDataSource: 'getDataSource' }),
        dataSource(){
            return this.documentDataSource?.Data?.Object?.Document?.TaskLists?.filter(list => list.TaskType == 2 && Array.isArray(list.Records) && list.Records.length > 0);
        },
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY HH:mm:ss');
            return formatedDate ?? "";
        }
    },
    methods: {
        update(){
        },
        getTakeNotes(list){
            if (list && Array.isArray(list.Records))
                return  [...list.Records].sort(function (a, b) { return a.SignerName.localeCompare(b.SignerName)});
            return []; 
        },
        getTitleCard(value){
            return this.$t('Лист_ознакомления_от_DateTime.message', { DateTime: sys.dateFormat(value, 'DD.MM.YYYY HH:mm:ss')})
        }
    },
}
</script>
